/**
 * 📄 Model representing a single subscription invoice
 */
export default class ProfitabilityByBot {
  constructor(
    public profit: number,
    public uid: string,
    public strategyName: string,
    public image: string,
    public exchange: string,
    public market: string,
    public candles: string,
    public enabled: boolean,
    public startTime: number,
    public stopTime: number
  ) { }
}